import React, { useEffect, useState } from "react";
import basseyimg from "../../assets/images/bassey2.webp";
import { ModalWrap } from "./ModalStyle.";
import { AiOutlineCloseCircle } from "react-icons/ai";

const Modal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("myFunctionExecuted") === "true") {
      return;
    }

    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    sessionStorage.setItem("myFunctionExecuted", "true");
  };

  if (sessionStorage.getItem("myFunctionExecuted") === "true") {
    return null;
  }

  return (
    <ModalWrap>
      {isOpen && (
        <div className="modal">
          <section>
            <div className="modal-body">
              <h1 onClick={closeModal}>
                <AiOutlineCloseCircle />
              </h1>
              <div>
                <img src={basseyimg} alt="" />
                <p>
                  <strong>Denukan Network Limited</strong> In Loving Memory of
                  Michael Elias Nseabasi Bassey
                  <br />
                  <br />
                  Today, Denukan Network Limited honors the memory of Bassey, a
                  colleague who was so much more than just a teammate. Though
                  time has passed, he remains an integral part of our story and
                  a presence we carry with us every day. We reflect on his
                  contributions and his character with immense gratitude.
                  Michael wasn't just a professional; he was a dear friend to
                  everyone fortunate enough to work alongside him.
                  <br />
                </p>
              </div>
            </div>
          </section>
        </div>
      )}
    </ModalWrap>
  );
};

export default Modal;
